'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12 0c3.304 0 6.13 1.174 8.478 3.522S24 8.696 24 12c0 3.304-1.174 6.13-3.522 8.478S15.304 24 12 24c-3.304 0-6.13-1.174-8.478-3.522S0 15.304 0 12c0-3.304 1.174-6.13 3.522-8.478S8.696 0 12 0Zm0 21.391c2.609 0 4.826-.921 6.652-2.765 1.826-1.843 2.74-4.052 2.74-6.626 0-2.609-.914-4.826-2.74-6.652-1.826-1.826-4.043-2.74-6.652-2.74-2.574 0-4.783.914-6.626 2.74C3.53 7.174 2.609 9.39 2.609 12c0 2.574.921 4.783 2.765 6.626C7.217 20.47 9.426 21.391 12 21.391Zm.94-16.174v6.366l3.912 3.913-1.304 1.304-4.435-4.435V5.217h1.826Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var Clock = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Clock = Clock;